import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { CurrencyManipulationView } from "./currencyManipulation-view"

export class CurrencyManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت واحد ‌پول ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.currencies = ObservableArray.create<currency>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new CurrencyManipulationView();
    }
    public getTypeId(): string {
        return "VM-0230121A-FC30-485A-B1E5-595D48604723"
    }
    public set currencies(v: ObservableArray<currency>) { this._currencies = v; } public get currencies(): ObservableArray<currency> { return this._currencies;} private _currencies: ObservableArray<currency>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllCurrencies',{
                FilteringInformation:filteringInformation
            });
            this.currencies.update(...result.Currencies.map(q=>{
                let r = new currency(this);
                r.id = q.Id;
                r.name = q.Name;
                r.symbol = q.Symbol;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestCurrencyCreation(){
        let editor = new currencyEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

}
export class currency extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set symbol(v: string) { this._symbol = v; } public get symbol(): string { return this._symbol;} private _symbol: string;
    
}

interface IServerUpdater{
    execute(currency:currency):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'واحد پول با موفقیت ثبت شد.';
    }
    async execute(currency: currency): Promise<void> {
        await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateCurrency',{
            Name:currency.name,
            Symbol:currency.symbol
        });
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'واحد پول با موفقیت به روز رسانی شد.';

    }
    execute(currency: currency): Promise<void> {
        throw new Error("Method not implemented.");
    }
}

export class currencyEditor extends currency implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام واحد پول مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.name)){
            result.push('نشانه واحد پول مشخص نشده است.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت واحد پول');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}